<template>
  <div>
    <h1>Home Screen</h1>
  </div>
</template>

<script>
export default {
  created() {
    this.show_close_loading("close");
    // Update store
    var payload = { headerType: "needHeader", currentPage: "HomeScreen" };
    this.$store.dispatch("updateHeaderType", payload);
    this.$store.dispatch("updateCurrentPage", payload);
  },
};
</script>

<style>
</style>